import { render, staticRenderFns } from "./CallTable.vue?vue&type=template&id=360b1876&scoped=true&"
import script from "./CallTable.vue?vue&type=script&lang=js&"
export * from "./CallTable.vue?vue&type=script&lang=js&"
import style0 from "./CallTable.vue?vue&type=style&index=0&id=360b1876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360b1876",
  null
  
)

export default component.exports